import React from 'react';

export const InsuranceEndDateInfo = () => (
  <>
    <p>
      Hoe langer u verzekerd bent hoe hoger de premie. De meeste mensen kiezen ervoor om de verzekering te
      laten lopen tot aan de pensioenleeftijd of deze aan te laten sluiten bij de einddatum van de hypotheek.
      Standaard wordt uw 67 jarige leeftijd als einddatum ingevuld. Voor sommige fysiek zware en creatieve beroepen
      geldt een maximale eindleeftijd van 60 jaar. Hiermee is nu geen rekening gehouden.
    </p>
  </>
);
